module.exports = __webpack_public_path__ + "img/2.c710963f.jpeg";